import usePlansApi from '../../plansApi';

export default function useRoadmapService() {
  const plansApi = usePlansApi();

  const markAsIncludedToRoadmap = async (ids: number[]) => {
    await plansApi.put('/plantasks/bulk/roadmap', {
      ids,
    });
  };

  return {
    markAsIncludedToRoadmap,
  };
}
